__turbopack_context__.v({
  "youtubeSubscribe": "YouTubeSubscribeButton-module-scss-module__JY65ga__youtubeSubscribe",
});
